import { tenureAddApi } from "../../api/tenure/tenureAddApi"

type PayloadShape = Parameters<typeof tenureAddApi>[0]

export async function tenureAddService(payload: PayloadShape, token: string) {
	return await tenureAddApi(payload, token)
}
